import React from 'react';

// Data for founders (same as before)
const ABHIJEET = {
  initials: 'ASJ', // using initials as in AboutPage
  name: 'Abhijeet Singh Jain',
  role: 'Co-Founder · Growth & Analytics',
  linkedin: 'https://linkedin.com/in/abhijeet-singh-jain',
  bio: '7+ years across India and the US. 20+ brands, EX-American Airlines to D2C startups. Rs.2Cr+ in ad budgets. MS in Business Analytics, UT Dallas.',
  skills: ['Meta Ads', 'Google Ads', 'SQL', 'Tableau', 'GA4', 'CRO', 'AI Automation'],
};

const ISHITA = {
  name: 'Ishita Jain',
  role: 'Co-Founder · UI/UX & CRO',
  linkedin: 'https://linkedin.com/in/ishitajain20',
  imgSrc: '/foundersimage/Ishita-Jain-2.jpeg',
  bio: '3+ years in D2C UI/UX and web dev. Built two D2C startups across US and India. Heatmaps, A/B tests, session data. NMIMS graduate.',
  skills: ['UI/UX Design', 'Shopify', 'Figma', 'CRO', 'A/B Testing', 'Web Dev'],
};

const FounderCard = ({ founder, isImage }) => (
  <div className="ap-founder-row ap-blur-reveal">
    <div className={isImage ? 'ap-founder-avatar' : 'ap-founder-avatar'}>
      {isImage ? (
        <img src={founder.imgSrc} alt={founder.name} className="ap-founder-photo" />
      ) : (
        <span className="ap-founder-initials">{founder.initials}</span>
      )}
    </div>
    <div className="ap-founder-info">
      <div className="ap-founder-top">
        <div>
          <h3 className="ap-founder-name">{founder.name}</h3>
          {founder.name === 'Abhijeet Singh Jain' ? (
            <p className="ap-founder-role">
              Co-Founder · <span className="scroll-hl" style={{ '--hl-d': '0s' }}>Growth & Analytics</span>
            </p>
          ) : founder.name === 'Ishita Jain' ? (
            <p className="ap-founder-role">
              Co-Founder · <span className="scroll-hl" style={{ '--hl-d': '0s' }}>UI/UX & CRO</span>
            </p>
          ) : (
            <p className="ap-founder-role">{founder.role}</p>
          )}
        </div>
        <a href={founder.linkedin} target="_blank" rel="noopener noreferrer" className="ap-founder-linkedin">
          LinkedIn ↗
        </a>
      </div>
      <p className="ap-founder-bio">
        {founder.name === 'Abhijeet Singh Jain' ? (
          <>
            <span className="scroll-hl" style={{ '--hl-d': '0s' }}>7+ years</span> across India and the US. 20+ brands, <span className="scroll-hl" style={{ '--hl-d': '0.15s' }}>EX-American Airlines</span> to D2C startups. Rs.2Cr+ in ad budgets. <span className="scroll-hl" style={{ '--hl-d': '0.3s' }}>MS in Business Analytics</span>, UT Dallas.
          </>
        ) : founder.name === 'Ishita Jain' ? (
          <>
            <span className="scroll-hl" style={{ '--hl-d': '0s' }}>3+ years</span> in D2C UI/UX and web dev. Built two <span className="scroll-hl" style={{ '--hl-d': '0.15s' }}>D2C startups across US and India</span>. Heatmaps, A/B tests, session data. <span className="scroll-hl" style={{ '--hl-d': '0.3s' }}>NMIMS</span> graduate.
          </>
        ) : (
          founder.bio
        )}
      </p>
      <div className="ap-founder-skills">
        {founder.skills.map(s => {
          return (
            <span key={s} className="ap-founder-skill">{s}</span>
          );
        })}
      </div>
    </div>
  </div>
);

export default function FoundersSection() {
  return (
    <section className="ap-founders-section">
      <div className="ap-founders-inner">
        <div className="ap-founders-header">
          <p className="ap-founders-label ap-blur-reveal">The Minds Behind Aurelix</p>
          <h2 className="ap-founders-heading ap-blur-reveal">
            Built on <span style={{ color: '#ec2b28' }}>data</span>,<br />
            driven by <span style={{ color: '#ec2b28' }}>results</span>.
          </h2>
        </div>
        <div className="ap-founders-list">
          {/* Top row: 2 founder cards + quote */}
          <div className="ap-founders-cards-row">
            {/* Abhijeet */}
            <FounderCard founder={ABHIJEET} isImage={false} />
            {/* Ishita */}
            <FounderCard founder={ISHITA} isImage={true} />
            {/* Quote */}
            <div className="ap-founders-quote ap-blur-reveal">
              <span className="ap-quote-mark">"</span>
              <p className="ap-quote-text">
                We built Aurelix because brands deserve an agency that connects ads, data, and operations into one system — focused on one thing: revenue.
              </p>
              <div className="ap-quote-attribution">
                <span>One team. Full accountability.</span>
                <span className="ap-quote-authors">Abhijeet &amp; Ishita, Co-Founders</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
